import { render } from "./BaseSportView.vue?vue&type=template&id=18f21137&scoped=true"
import script from "./BaseSportView.vue?vue&type=script&lang=js"
export * from "./BaseSportView.vue?vue&type=script&lang=js"

import "./BaseSportView.vue?vue&type=style&index=0&id=18f21137&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f21137"]])

export default __exports__